var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { title: "Memo", visible: _vm.dialogVisible, width: "546px" },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        }
      }
    },
    [
      _c("el-input", {
        attrs: {
          type: "textarea",
          rows: "10",
          maxlength: "500",
          "show-word-limit": ""
        },
        nativeOn: {
          keydown: function($event) {
            return _vm.memoChange($event)
          }
        },
        model: {
          value: _vm.memo,
          callback: function($$v) {
            _vm.memo = $$v
          },
          expression: "memo"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "memo-footer" }, [
        _c(
          "span",
          {
            staticClass: "dialog-footer",
            attrs: { slot: "footer", center: "" },
            slot: "footer"
          },
          [
            _c(
              "el-button",
              {
                staticClass: "memo-footer-button btn-black",
                attrs: { type: "primary" },
                on: { click: _vm.editSubmit }
              },
              [_vm._v("Submit")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "memo-footer-button",
                on: {
                  click: function($event) {
                    _vm.dialogVisible = false
                  }
                }
              },
              [_vm._v("Cancel")]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b1e35830", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1e35830","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/edit-memo.vue
// module id = Dq/N
// module chunks = 2